export const CLEAR = 'CLEAR';
export const ACCOUNT_BALANCE = 'ACCOUNT_BALANCE';
export const LEAD_ALERT_SETTINGS = 'LEAD_ALERT_SETTINGS';
export const COMPANY_USER = 'COMPANY_USER';
export const MAIN_LISTING = 'MAIN_LISTING';
export const COMPANY = 'COMPANY';
export const COMPANY_LOCALE = 'COMPANY_LOCALE';